import {Box, useDisclosure} from '@chakra-ui/react';
import {useTranslation} from 'hooks';
import {useRouter} from 'next/router';
import React, {FC, useMemo, useState} from 'react';
import {IProduct, IRestaurantResponse, ProviderTypeEnum} from 'types';

import {MetroSearchInput} from '../../../shared/metro-search';
import {useMetroSearch} from '../../api/queries';
import {MetroProductDetailsModal} from '../metro-product-details-modal';

interface IProps {
  providerType?: ProviderTypeEnum;
  heightLG?: boolean;
  provider?: IRestaurantResponse;
}

export const MetroSearch: FC<IProps> = React.memo(({provider, heightLG}) => {
  const {query} = useRouter();
  const searchQuery = query.query as string;
  const [searchValue, setSearchValue] = useState(searchQuery ?? '');
  const [selectedProductSlug, setSelectedProductSlug] = useState<string>();
  const [currentHref, setCurrentHref] = useState<string>();

  const {t} = useTranslation();

  const {
    isOpen: isOpenMetroProductModal,
    onOpen: onOpenMetroProductModal,
    onClose: onCloseMetroProductModal,
  } = useDisclosure();

  const {data, isFetching} = useMetroSearch(searchValue, {
    enabled: searchValue.length > 1,
  });

  const placeholder = useMemo(() => {
    return `${t('SEARCH_IN')} METRO`;
  }, [t]);

  const handleProductClick = (product: IProduct) => {
    setCurrentHref(window.location.href);
    setSelectedProductSlug(product.slug);
    onOpenMetroProductModal();
  };

  const handleCloseModal = () => {
    window.history.replaceState(null, '', currentHref);
    onCloseMetroProductModal();
  };

  return (
    <Box>
      <MetroSearchInput
        placeholder={placeholder}
        value={searchValue}
        onChange={setSearchValue}
        data={data}
        onProductClick={handleProductClick}
        heightLG={heightLG}
        isLoading={isFetching}
        provider={provider}
      />

      {isOpenMetroProductModal && selectedProductSlug && (
        <MetroProductDetailsModal
          isOpen={isOpenMetroProductModal}
          onClose={handleCloseModal}
          productSlug={selectedProductSlug}
          provider={provider}
        />
      )}
    </Box>
  );
});
